module.exports = __webpack_public_path__ + "static/media/welcome-tile-sensors.f9642ef5.png";